import { ACTIVE_SERVER_ID } from 'mk/settings';
import { ID_RE, SLUG_RE } from 'mk2/helpers/urls';

const STROLLER_SLUG = `:slug(${SLUG_RE})`;
const BRAND_SLUG = `:slug(${SLUG_RE})`;
const REVIEW_ID = `:reviewId(${ID_RE})`;
const PHOTO_ID = `:photoId(${ID_RE})`;
const STROLLER_PHOTO_ID = `:photoId([sr]${ID_RE})`;

const strollersPrefixes = {
    201: '/kocikopedia',
    202: '/kocarkopedie',
    207: '/strollers',
};
const strollersPrefix = strollersPrefixes[ACTIVE_SERVER_ID];

export const strollersUrl = `${strollersPrefix}/`;

export const strollersSearchUrl = `${strollersPrefix}/search/:pageMode(edit|results|all)/`;

export const strollersWishlistUrl = `${strollersPrefix}/wishlist/`;
export const strollersChartsUrl = `${strollersPrefix}/charts/`;

export const strollersListUrl = `${strollersPrefix}/brand/${BRAND_SLUG}/`;

export const strollersDetailUrl = `${strollersPrefix}/${STROLLER_SLUG}/`;
export const strollersPhotoUrl = `${strollersDetailUrl}image/${STROLLER_PHOTO_ID}/`;
export const strollersAddReviewUrl = `${strollersDetailUrl}add_review/`;
export const strollersAddReviewScoreUrl = `${strollersDetailUrl}add_review/:screen(score)/`;
export const strollersReviewUrl = `${strollersDetailUrl}review/${REVIEW_ID}/`;
export const strollersReviewPhotoUrl = `${strollersDetailUrl}review/${REVIEW_ID}/image/${PHOTO_ID}/`;
export const strollersReviewsUrl = `${strollersDetailUrl}reviews/`;

export const strollersAddQuestionUrl = `${strollersDetailUrl}add_question/`;

export const strollersDetailAlternateUrl = (server) => `${strollersPrefixes[server]}/${STROLLER_SLUG}/`;
